import type { SidePanel } from '../types';

export const ChangePassword: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./PassPanel.vue')),
};
